export interface ReasonRejectedMobilityDto {
  reasonRejectTransferItemRequestId: number;
  detail: string;
}

export class ReasonRejectedMobility {
  reasonRejectTransferItemRequestId: number;
  detail: string;

  constructor({ reasonRejectTransferItemRequestId, detail }: ReasonRejectedMobilityDto) {
    this.reasonRejectTransferItemRequestId = reasonRejectTransferItemRequestId;
    this.detail = detail;
  }
} 